import React from 'react';
import './Footer.css';
import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="footer-section">
      <div className="container">
        <div className="footer-grid">
          <div className="footer-column">
            <h4>About Us</h4>
            <p>
              Home Appliance Assist is your trusted partner in providing expert repairing services for all types of home appliances.
              We are committed to delivering reliable and efficient solutions to keep your appliances running smoothly.
            </p>
          </div>

          <div className="footer-column">
            <h4>Quick Links</h4>
            <ul>
              <li><Link to="/washing-machine-service">Washing Machine Service</Link></li>
              <li><Link to="/fridge-service">Fridge Service</Link></li>
              <li><Link to="/ac-service">AC Service</Link></li>
              <li><Link to="/tv-service">TV Service</Link></li>
              <li><Link to="/Micro">Microwave Oven Service</Link></li>
            </ul>
          </div>

          <div className="footer-column">
            <h4>Privacy Policy</h4>
            <p>
              We value your privacy and are committed to protecting your personal information.
              <br />
              <Link to="/privacy-policy">Read our Privacy Policy</Link> to learn more.
            </p>
          </div>

          <div className="footer-column">
            <h4>Terms & Conditions</h4>
            <p>
              Please review our <Link to="/terms-conditions">Terms and Conditions</Link> to understand the rules and guidelines for using our services and website.
            </p>
          </div>
        </div>

        <div className="footer-bottom">
          © 2025 <strong>Home Appliance Assist</strong>. All rights reserved.
        </div>
      </div>
    </footer>
  );
}
